import {Component, computed, DestroyRef, inject,} from '@angular/core';
import { CartService} from '~shared/services/cart.service';
import { SessionService} from "~core/services/session.service";
import {TranslatePipe, _,  TranslateService} from '@ngx-translate/core';
import {NavigateService} from "~shared/services/navigate.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {CurrencyPipe} from "@angular/common";
import {OrderService} from "~features/checkout/services/order.service";
import {OrderRequest} from "~features/checkout/models/order-request.model";
import {CartItem} from "~shared/models/cartitem.model";
import {EMPTY, finalize} from "rxjs";
import {catchError} from "rxjs/operators";
import {AlertService} from "~core/services/ui/alert.service";
import {OrderError, OrderResponse} from "~features/checkout/models/order-response.model";


@Component({
  selector: 'app-footer',
  imports: [TranslatePipe, CurrencyPipe,],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  standalone: true,
})
export class FooterComponent {
  cartService = inject(CartService);
  sessionService: SessionService=inject(SessionService);
  navigateService: NavigateService=inject(NavigateService);
  orderService=inject(OrderService);
  translate = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly alertService = inject(AlertService);


  footerenabled = computed(() =>{
    let test = this.cartService.itemCount()>0 && (this.navigateService.pageTitle() === 'home' || this.navigateService.pageTitle() === 'cart');
    return (test);
  });

  ishippinginfoconfirmed = computed<boolean>(() => {
    return this.cartService.shipaddressConfirmed()&&this.cartService.isshippinginfoValid();
  });

  get cart() {
    return this.cartService.items;
  }

  get cartTotal() {
    return this.cartService.subtotal_net();
  }

  get cartGrossTotal() {
    return this.cartService.Gross_Total();
  }


  /*
  private nextPage() {
    this.navigateService.nextPage();
  }

   */

  navigateToCart() {
    this.navigateService.navigateTo('cart');
  }

  navigateToCheckout() {
    this.navigateService.navigateTo('checkout');
  }

  AnnullaOrdine(){
    this.navigateService.goHome()
  }

  placeOrder() {
    if (this.cartService.isshippinginfoValid()) {
      console.log("PlaceOrder");
      const fullname = (this.cartService.customerinfo().name + ' ' + this.cartService.customerinfo().surname).trim();
      let note = this.cartService.customerinfo().notes;
      if (this.cartService.customerinfo().shippingDate!=null) {
        note ='Spedire a partire da ' + this.cartService.customerinfo().shippingDate?.toLocaleDateString()+'\n'+note;
      }
      let marketing_consent =null;
      if (this.cartService.customerinfo().marketing_consent!=null)
      {
        marketing_consent = this.cartService.customerinfo().marketing_consent?'S':'N';
      }
      let request: OrderRequest = {
        company: this.sessionService.getCompanyId(),
        fees : this.cartService.fees(),
        shipping_cost : this.cartService.shippingCost(),
        order_id : this.cartService.getOrderID(),
        country: this.cartService.customerinfo().country,
        vat: this.cartService.vat_total(),
        insurance: this.cartService.customerinfo().insurance,
        order_notes: note,
      //  parcels_info:[],
        total:this.cartService.Gross_Total(),
        products: this.cartService.items().map((item:CartItem) => {
          return {
            sku: item.product.id,
            qty: item.quantity,
            total_without_tax: this.cartService.getTotalNetItem(item.product,item.quantity)
          }
        }),
        customer_data: {
          customer: fullname,
          name:this.cartService.customerinfo().name,
          surname:this.cartService.customerinfo().surname,
          email: this.cartService.customerinfo().email,
          phone: this.cartService.customerinfo().phone,
          address: this.cartService.customerinfo().address,
          city: this.cartService.customerinfo().city,
          postcode: this.cartService.customerinfo().zip,
          state: this.cartService.customerinfo().state,
          country: this.cartService.customerinfo().country,
          privacy_terms_consent: this.cartService.customerinfo().privacy_terms_consent?'S':'N',
          marketing_consent:marketing_consent,
        },
        b2b:false,
        require_shipment: this.sessionService.IsRequiredShipment(),
        source: 'selforder',
        payment_method: this.cartService.payment(),
        }
      try {
        this.orderService
            .calculateorder(request)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                finalize(() => {
                  console.log("Shipping cost calculated");
                }),
                catchError((error: any) => {
                  this.handleOrderError(error);
                  return EMPTY;
                }),
            )
            .subscribe({
              next: (data: OrderResponse|OrderError) => {
                if (data) {
                  this.navigateService.navigateTo('success');
                  return;
                }
                else {
                  this.handleOrderError("Generic Error");
                  return EMPTY;
                }
              },
            });
      }
      catch (error:any){
        console.error('Error during calculation of shipping cost:', error);
        this.translate.get(_("genericErrorAlert"))
            .subscribe((text: string) => {
              this.alertService.createErrorAlert(`${text}`);
            });
      }
    /*  this.cartService.clearCart();
      this.navigationService.navigateTo('success');*/
    }
  }

  private handleOrderError(response: any): void {
    console.log("Order error:", response);
    this.translate.get(_('ordererror'))
        .subscribe((text: string) =>
        {
          this.alertService.createErrorAlert(`${text}`);
        });
  }

}
